import { useStyleConfig } from '@chakra-ui/react';

import type { ProductBadgeProps } from './index';
import { ProductBadge } from './index';

const CARD_CONTAINER_BREAKPOINT = 280;

export function ProductBadgeContained({ sx, ...props }: ProductBadgeProps) {
  const badgeSizeSm = useStyleConfig('Badge', { size: 'sm' });

  return (
    <ProductBadge
      size="md"
      m="sm"
      sx={{
        [`@container (max-width: ${CARD_CONTAINER_BREAKPOINT}px)`]: {
          height: '23px',
          fontSize: badgeSizeSm.fontSize,
          fontWeight: badgeSizeSm.fontWeight,
          lineHeight: badgeSizeSm.lineHeight,
          px: badgeSizeSm.px,
          pt: badgeSizeSm.pt,
          m: '2xs',
        },
        ...sx,
      }}
      {...props}
    />
  );
}
